export const urlAlphabet =
  'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict'



//////////////////
// WEBPACK FOOTER
// ./~/nanoid/url-alphabet/index.js
// module id = 1112
// module chunks = 0